import clusterGraphReducer from "./reducer";

import ClusterGraphResponseTransformed from "../../../domains/ClusteringGraph/ClusterGraphResponseTransformed";

import {
  generateClusterGraph,
  generateClusterGraphSuccess,
  generateClusterGraphError,
  openGraphModal,
  closeGraphModal
} from "./actions";

export interface ClusterGraphState {
  isDataLoading: boolean
  clusterGraphData: ClusterGraphResponseTransformed
  hasErrorLoadingData: boolean
  isGraphModalOpen: boolean
}

export const initialState = {
  isDataLoading: false,
  clusterGraphData: {},
  hasErrorLoadingData: false,
  isGraphModalOpen: false,
};

export {
  generateClusterGraph,
  generateClusterGraphSuccess,
  generateClusterGraphError,
  openGraphModal,
  closeGraphModal
};

export default clusterGraphReducer;
